import { render } from "./CourseCard.vue?vue&type=template&id=4a8c1330&scoped=true"
import script from "./CourseCard.vue?vue&type=script&lang=js"
export * from "./CourseCard.vue?vue&type=script&lang=js"

import "./CourseCard.vue?vue&type=style&index=0&id=4a8c1330&lang=scss&scoped=true"

import exportComponent from "/root/.jenkins/workspace/外网-云南农业大学-前台页面/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a8c1330"]])

export default __exports__